import { Observable } from 'rxjs';
import { PromptQuotaStatus } from '../../chatbot-core/chatbot-api/prompt-quota-status.model';

/**
 * Interface for chatbot history service operations.
 * Implement this interface in the client app to provide logic for loading chat history.
 */
export interface IChatbotHistoryApiService {
  /**
   * Retrieves the chat history groups organized by date.
   * @returns An observable emitting an array of ChatHistoryGroup objects.
   */
  getSessions(searchText: string, params: LazyLoadQueryParams): Observable<DataPageDTO<SessionHistoryDTO>>;

  getSession(sessionId: number): Observable<SessionDTO>;

  /**
   * Updates the title of a session.
   * @param sessionId - The session id (numeric).
   * @param newTitle - The new title for the session.
   * @returns An observable that completes when the update is successful.
   */
  updateSessionTitle(sessionId: number, newTitle: string): Observable<void>;
}


export interface DataPageDTO<T> {
  rows: T[];
}

/**
 * Represents a single chat session
 */
export interface SessionHistoryDTO {
  sessionId: number;
  llmSessionId: string;
  sessionTitle: string;
  date: Date;
}

export interface LazyLoadQueryParams {
  includeCount: boolean;
  toSkip: number;
  rowsCount: number;
  sortField: string | null;
  sortDirection: SortDirection | null;
  filter: LazyLoadFilterParams | null;
}
export enum SortDirection {
  Ascending = 1,
  Descending
}
export interface LazyLoadFilterParams {
  conditions: FieldCondition[];
}
export interface FieldCondition {
  fieldName: string;
  operator: string;
  value: string | null;
  valueObject: any | null;
}




export interface SessionDTO {
  sessionId: number;
  llmSessionId: string;
  sessionsQuota: SessionsQuotaDTO;
  promptsQuota: PromptQuotaStatus;
  messages: MessageHistoryDTO[];
}
export interface SessionsQuotaDTO {
  sessionsCount: number;
  remainingSessionsCount: number;
  showWarning: boolean;
  limitReached: boolean;
  isLastSession: boolean;
  messages: MessageHistoryDTO[];
}
export interface MessageHistoryDTO {
  userMessage: string;
  date: Date;
  isReplyInterrupted: boolean;
  reply: string | null;
}
